@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

[data-fpsm-theme='oddschecker'],
[data-fpsm-theme='plus'],
[data-fpsm-theme='whoscored'],
[data-fpsm-theme='gazzetta'] {
  --slider-inactive: initial;
}

[data-fpsm-theme='plus'] {
  --slider-inactive: #839ba8;
}

[data-fpsm-theme='whoscored'] {
  --slider-inactive: #7d7d7d;
}

[data-fpsm-theme='gazzetta'] {
  --slider-inactive: #4a4a4a;
}

.size-s {
  --slider-track: 4px;
  --slider-thumb: 12px;
  --slider-radius: 3px;

  .output {
    @include cxy.font-size('text-s', var(--cxy-fontWeight-bold));
  }
}

.size-m {
  --slider-track: 6px;
  --slider-thumb: 16px;
  --slider-thumb--mobile: 24px;
  --slider-radius: var(--cxy-border-radius-s);

  .output {
    @include cxy.font-size('text-m');
  }
}

.sliderWrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--cxy-spacing-0);

  @include cxy.screen-size('desktop') {
    gap: var(--cxy-spacing-xxsm);
    flex-direction: row;
  }

  .label {
    white-space: nowrap;
  }
}

.labelContainer {
  display: flex;
  align-items: center;
}

.controlsWrapper {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-xxsm);
  width: 100%;
}

.inputsContainer {
  padding: var(--cxy-spacing-xxsm) 0;
  display: flex;
  gap: var(--cxy-spacing-xxsm);
  justify-content: space-between;
}

.inputWrapper {
  max-width: 54px;
  width: 100%;

  input {
    border-radius: var(--cxy-border-radius-s);
    border: 1px solid rgba(255, 255, 255, 0.5);
  }

  input[type='number'] {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    -moz-appearance: textfield;

    width: 100%;
    box-sizing: border-box;
    padding-right: var(--cxy-spacing-xxsm);
  }
}

.sliderContainer {
  display: flex;
  width: 100%;
  gap: var(--cxy-spacing-xxsm);
  color: var(--cxy-color-text-default-body);

  &.shouldShowBackground {
    padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
    background-color: color-mix(in srgb, var(--cxy-color-content-on-inverse), transparent 90%);

    border-radius: var(--cxy-border-radius-xl);

    .track {
      background-color: var(--cxy-color-surface-default);
    }
  }
}

.slider {
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
}

.track {
  position: relative;
  flex-grow: 1;
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
  border-radius: var(--slider-radius);
  height: var(--slider-track);
  width: 100%;
}

.range {
  position: absolute;
  background-color: var(--cxy-color-brand);
  border-radius: var(--slider-radius);
  height: var(--slider-track);
}

.thumb {
  display: block;
  width: var(--slider-thumb--mobile, var(--slider-thumb));
  height: var(--slider-thumb--mobile, var(--slider-thumb));
  border-radius: 50%;
  background-color: var(--cxy-color-brand);
  box-shadow: var(--cxy-box-shadow-a);

  &:focus-visible {
    @include cxy.focus-ring(var(--cxy-box-shadow-a));
  }

  &.noValue {
    background-color: var(--slider-inactive, #ccd5db);
  }

  @include cxy.screen-size('desktop') {
    width: var(--slider-thumb);
    height: var(--slider-thumb);
  }
}

.output {
  display: flex;
  min-width: 3ch;
  margin: 0;
  justify-content: flex-end;

  span {
    white-space: nowrap;
  }
}

.sliderInput {
  padding: var(--cxy-spacing-xxsm) !important;
}

[data-fpsm-theme='gazzetta'] {
  .sliderContainer {
    .output {
      color: var(--cxy-color-text-default-body);
    }
    .track {
      background-color: var(--slider-track-color, #808080);
    }

    &.shouldShowBackground {
      background-color: var(--cxy-color-container-strong);

      .thumb {
        background-color: var(--cxy-color-surface-default);
      }
      .range {
        background-color: var(--cxy-color-surface-default);
      }
      .track {
        background-color: var(--cxy-color-container-track);
      }
      .output {
        color: var(--cxy-color-text-default-placeholder);
      }
    }
  }
}
